export default {
    cantico: {
      title: 'Il Cantico delle Creature',
      subtitle: 'di San Francesco d\'Assisi',
      headerOriginal: 'Lingua originale del 1225',
      headerTranslations: 'Versione in ucraino',
      text: `Високий, всемогутний, добрий Господе,
Тобі слава, честь і похвала,
і всяке благословення.
Лише Тобі, Високий Господе, подобається честь,
і жодна людина не гідна назвати Твоє ім'я.

Славлю Тебе, Господи мій, з усіма Твоїми творіннями,
особливо з паном братом Сонцем,
що приносить день і освітлює нас своїм світлом.
Воно прекрасне і сяє з великою славою:
Тобі, Високий Господе, несе воно знак.

Славлю Тебе, Господи мій, за сестру Місяць і зірки:
на небі Ти створив їх ясними,
дорагоцінними і прекрасними.

Славлю Тебе, Господи мій, за брата Вітер
та за повітря, хмари і ясне небо,
і всяку погоду, якою Ти даєш
пропітання Твоїм творінням.

Славлю Тебе, Господи мій, за сестру Воду,
яка дуже корисна
і смирна, і дорогоцінна, і чиста.

Славлю Тебе, Господи мій, за брата Вогонь,
яким Ти освітлюєш ніч,
і він прекрасний і радісний,
могутній і сильний.

Славлю Тебе, Господи мій, за нашу сестру Матір-Землю,
яка годує нас і керує нами,
і виробляє різні плоди
з різнокольоровими квітами і травами.

Славлю Тебе, Господи мій, за тих, хто прощає
заради Твоєї любові та переносить
хворобу і страждання.
Благослови тих, хто переносить це в мирі,
бо Ти, Високий Господе, їх увінчаєш.

Славлю Тебе, Господи мій, за нашу сестру тілесну Смерть,
від якої не може втекти жива людина.
Горе тим, хто вмирає в смертному гріху!
Благослови тих, кого вона застане виконуючими
святу волю Твою,
бо друга смерть не завдасть їм шкоди.

Славте і благословляйте Господа,
і дякуйте Йому,
і служіть Йому з великою смирністю.`
    }
  }